module.exports = __webpack_public_path__ + "static/img/winSuccess.0b0a9f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/winSuccess.png
// module id = wpjH
// module chunks = 1